import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Temoignage } from '../models/temoignage.model';

@Injectable({
  providedIn: 'root'
})
export class TemoignageService {

  private apiUrl = 'https://be.festivalsousse.com/api/temoignages';

  constructor(private http: HttpClient) { }

  getAll(): Observable<Temoignage[]> {
    return this.http.get<Temoignage[]>(this.apiUrl);
  }

  getApprouves(): Observable<Temoignage[]> {
    return this.http.get<Temoignage[]>(`${this.apiUrl}/approuves`);
  }

  // Soumission publique depuis la page d'accueil (part en statut "attente")
  creer(temoignage: Temoignage): Observable<Temoignage> {
    return this.http.post<Temoignage>(this.apiUrl, temoignage);
  }

  // Ajout manuel depuis l'admin (publie directement)
  creerParAdmin(temoignage: Temoignage): Observable<Temoignage> {
    return this.http.post<Temoignage>(`${this.apiUrl}/admin`, temoignage);
  }

  changerStatut(id: number, statut: string): Observable<Temoignage> {
    return this.http.put<Temoignage>(`${this.apiUrl}/${id}/statut`, { statut });
  }

  supprimer(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
